module.exports = __webpack_public_path__ + "img/cogcom_logo.88e7b38e.png";